import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { BusinessContactService } from './services/business-contact.service';
import { BusinessService } from '../../../../../common/services/Business.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { FireBaseService } from '../../../../../common/services/FireBase.service'
import { TranslateService } from '@ngx-translate/core';
// import {LinkSaleoutService} from '../../../qrcode/batchstamp/linkSaleout/services/linkSaleout.service';

declare var $: any;

@Component({
  selector: 'app-business-contact',
  templateUrl: 'business-contact.component.html',
  styleUrls: ['business-contact.component.css'],
  providers: [BusinessService, BusinessContactService],
})
export class BusinessContactComponent implements OnInit {

  public businessForm: FormGroup;
  public businessContact: any = {};
  public images: any = {};
  public checkValidateAccount: any;
  public dataValidateAccount: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private _location: Location,
    private BusinessContactService: BusinessContactService,
    private Bussiness: BusinessService,
    private fireBaseService: FireBaseService,
    private upload: UploadService,
    private translate: TranslateService,
    // public linkSaleoutService: LinkSaleoutService,

  ) {
  }

  ngOnInit() {
    this.createFrom();
    this.getBusinessContact();
    // this.getData();
  }

  backToComponent() {
    this.businessForm.reset();
    this.deleteImage();
  }

  getBusinessContact() {
    console.log('99999999999')
    this.Bussiness.getBusinessContact().subscribe((res) => {
      if (res.code === 1) {
        this.businessContact = res.data
        let avatar = res.data.avatar
        if (this.businessContact) {
          (<FormControl>this.businessForm.controls['phone']).setValue(this.businessContact.phone);
          (<FormControl>this.businessForm.controls['email']).setValue(this.businessContact.email);
          this.images.url = avatar ? avatar : '';
          this.images.id = res.data.avatarId ? res.data.avatarId : null;
          const userBussinessProfile = JSON.parse(localStorage.getItem('User'));
          userBussinessProfile['avatar'] = avatar;
          userBussinessProfile['email'] = this.businessContact.email;
          userBussinessProfile['phone'] = this.businessContact.phone;
          localStorage.setItem('User', JSON.stringify(userBussinessProfile));
          console.log('user ', userBussinessProfile)
          this.BusinessContactService.profileBussinessUpdate$.next(userBussinessProfile)
        }
        console.log('data', this.businessContact);
      }
    })
  }

  // async getData() {
  //   await this.linkSaleoutService.validateAccountSaleOut().subscribe((res) => {
  //     console.log('ressss', res)
  //     if (res.data.items.length == 0) {
  //       this.checkValidateAccount = false;
  //     } else {
  //       const data = res.data.items;
  //       data.map((val) => {
  //         if (val.systemType == 0) {
  //           this.dataValidateAccount = val
  //         }
  //       })
  //     }
  //     console.log('this.dataValidateAccount', this.dataValidateAccount)
  //     if (this.dataValidateAccount) {
  //       this.checkValidateAccount = true;
  //     }
  //     localStorage.setItem('checkValidateAccount', this.checkValidateAccount)
  //   })
  // }

  createFrom() {
    this.businessForm = this.fb.group({
      phone: '',
      email: '',
      avatar: ''
    })
  }

  tusUpload = (item: any) => {
    console.log(123123);
    const numberImages = item.target.files.length
    if (numberImages > 1) {
      this.toastr.error(this.translate.instant('CHI_DUOC_UPLOAD_TOI_DA_1_ANH'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            this.images = {
              id: res.data.fileId,
              url: res.data.url,
            };
          }
        });

      }
    }
  }

  deleteImage() {
    this.images.url = null;
    this.images.id = null;
  }

  onSubmit() {
    const body = {
      phone: this.businessForm.value.phone,
      email: this.businessForm.value.email,
      avatar: this.images ? this.images.url : ''
    }
    console.log('123123123', body);
    this.Bussiness.updateBusinessContact(body).subscribe((res) => {
      console.log(res);
      if (res.code == 1) {
        this.toastr.success(this.translate.instant('CAP_NHAT_THANH_CONG'), '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.getBusinessContact();
      } else {
        this.toastr.error(this.translate.instant('CAP_NHAT_THAT_BAI'), '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return;
      }
    });

  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/business-contact/business-contact.component.ts